/**
 * Semantic rule for FogVolume: `size` authored while `shape` is World. Advisory, like `Range`'s
 * `max_value`-below-`min_value` rule: legal Godot with an inert consequence. linterParser.ts
 * validates format.
 */
import { ruleRegistry } from '../../../linter/RuleRegistry.js';
import { ruleInt } from '../../../godot/variant/intSlots.js';
import { armDiagnostic, armEmits, groundedArm } from '../../../linter/ruleArms.js';
const arms = {
    sizeIgnoredForWorldShape: groundedArm('fogvolume-size-ignored-for-world-shape', {
        kind: 'engine-inert',
        at: 'fog.cpp:702',
        unused: 'the world shape never enters the branch that reads the extents',
    }),
};
/** `RS::FogVolumeShape::FOG_VOLUME_SHAPE_WORLD`, fog_volume.cpp:47's 5th enum value. */
const FOG_VOLUME_SHAPE_WORLD = 4;
// `_validate_property` (fog_volume.cpp:51-54) hides `size` for the World shape, but a hand-authored
// `.tscn` can carry both keys, and the strict scanner reads properties by name. The fog pass reads
// `extents` only under `if (volume_type != RS::FOG_VOLUME_SHAPE_WORLD)`
// (servers/rendering/renderer_rd/environment/fog.cpp:702), so such a size is stored, never drawn.
function checkFogVolumeSize(context) {
    const { node } = context;
    const props = node.rawProperties;
    const shapeRaw = props.shape;
    const sizeRaw = props.size;
    if (shapeRaw === undefined || sizeRaw === undefined)
        return [];
    if (ruleInt(shapeRaw) !== FOG_VOLUME_SHAPE_WORLD)
        return [];
    return [
        armDiagnostic(arms.sizeIgnoredForWorldShape, node, `FogVolume 'size = ${sizeRaw}' has no effect while 'shape = ${shapeRaw}' (World). A World-shaped FogVolume's extents are never consulted by the volumetric fog pass (fog.cpp:702), and the editor itself hides 'size' for this shape (fog_volume.cpp:52).`),
    ];
}
const fogVolumeSizeRule = {
    meta: {
        name: 'valid-fogvolume-size',
        description: "Flags a FogVolume authoring 'size' while 'shape' is World, where Godot's renderer never consults it",
        category: 'validation',
        applicableNodeTypes: ['FogVolume'],
        emits: armEmits(arms),
    },
    check: checkFogVolumeSize,
};
ruleRegistry.register(fogVolumeSizeRule);
//# sourceMappingURL=linter.js.map